import React, { useEffect, useState } from "react";
// import UploadFile from "./filePond";
import { Container, Row, Col } from "react-bootstrap";
import Upload from "./Upload";
import { useDispatch } from 'react-redux';

import { setButtonsText } from "../../store/banner/bannerSlice";
import { getConfiguredLabel } from "../../common/commonHelper";
import { banner, HomePage, mainHeader, subHeader } from "../../common/labelConstants";
import { HomepageBottomSection } from "./homepageBottomSection";
export function Homepage () {
    const [files,setFiles] = useState([])
    const dispatch = useDispatch();
    const bannerContent = {
        tabName: getConfiguredLabel(HomePage,banner),
        actionsJSX: <>
            <div className='cancel-save-btns'>
               
            </div>
        </>
    }

    useEffect(() => {
        dispatch(setButtonsText(bannerContent))
        return () => {
            dispatch(setButtonsText(null))
        }
    }, [])
    
    const setFilesCb =(arr)=>{

       setFiles(arr)
    }
    return<div className="homepage">
        <div className="body_container">
            <Container>
            <div className='top_content'>
                <Row>
                    <Col md={12}>
                        <div className="content_wrapper">
                            <h1>{getConfiguredLabel(HomePage,mainHeader)}</h1>
                            <p>{getConfiguredLabel(HomePage,subHeader)}</p>
                        </div>
                    </Col>
                </Row>
            </div>
            {files.length === 0 && <HomepageBottomSection />}
            {files.length > 0  && <div className="rc_small_homebutton_Section">
            <HomepageBottomSection /> </div>}
                <div className="slb-upload_wrapper-main">
                    <div className="upload_wrapper">
                        <Row>
                            <Col md={12}>
                                <Upload setFilesCb={setFilesCb} />
                            </Col>
                        </Row>
                    </div>
                    <div className="slb-upload-shadow-main">
                        <div className="upload_wrapper_shadow"></div>
                    </div>
                </div>
              
            </Container>
        </div>
    </div>
}